export const Switch = ({ test, children }) => {
    return (children.find((child) => {
        return child?.props["value"] === test;
    }) || null);
};
//# sourceMappingURL=Switch.js.map